import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";
import { ReactComponent as EvidenceCompletedIcon } from "../../assets/complianceIcons/completed-icon.svg";
import { ReactComponent as CustomRegistryDark } from "../../assets/complianceIcons/custom-registry-dark.svg";
import { ReactComponent as CustomRegistry } from "../../assets/complianceIcons/custom-registry.svg";
import { ReactComponent as EuaiLogo } from "../../assets/complianceIcons/eu-ai-act-logo.svg";
import { ReactComponent as HITRUSTDark } from "../../assets/complianceIcons/hitrust-dark.svg";
import { ReactComponent as HITRUSTLight } from "../../assets/complianceIcons/hitrust-light.svg";
import { ReactComponent as IsoLogoDark } from "../../assets/complianceIcons/iso-logo-dark.svg";
import { ReactComponent as IsoLogo } from "../../assets/complianceIcons/iso-logo.svg";
import { ReactComponent as NistLogoDark } from "../../assets/complianceIcons/nist-logo-dark.svg";
import { ReactComponent as NistLogo } from "../../assets/complianceIcons/nist-logo.svg";
import { ReactComponent as EvidenceOverdueIcon } from "../../assets/complianceIcons/overdue-icon.svg";
import { ReactComponent as EvidencePendingIcon } from "../../assets/complianceIcons/pending-icon.svg";
import { ReactComponent as RiskScenarioIcon } from "../../assets/complianceIcons/risk-scenario.svg";
import { ReactComponent as UseCaseRegistryDark } from "../../assets/complianceIcons/use-case-registry-dark.svg";
import { ReactComponent as UseCaseRegistry } from "../../assets/complianceIcons/use-case-registry.svg";
import { ReactComponent as VendorRegistryDark } from "../../assets/complianceIcons/vendor-registry-dark.svg";
import { ReactComponent as VendorRegistry } from "../../assets/complianceIcons/vendor-registry.svg";
import { ReactComponent as AddIcon } from "../../assets/general/add-icon.svg";
import { ReactComponent as AgentExecutorIcon } from "../../assets/general/agent-executor.svg";
import { ReactComponent as AgentsConnectorIcon } from "../../assets/general/agents-connector.svg";
import { ReactComponent as AINoBackgroundDarkIcon } from "../../assets/general/ai-nobg-dark.svg";
import { ReactComponent as AINoBackgroundIcon } from "../../assets/general/ai-nobg.svg";
import { ReactComponent as AppendIcon } from "../../assets/general/append.svg";
import { ReactComponent as AuditLogIcon } from "../../assets/general/audit-log.svg";
import { ReactComponent as CalendarDarkIcon } from "../../assets/general/calendar-dark.svg";
import { ReactComponent as CalendarLightIcon } from "../../assets/general/calendar-light.svg";
import { ReactComponent as CautionIcon } from "../../assets/general/caution.svg";
import { ReactComponent as CheckIcon } from "../../assets/general/check.svg";
import { ReactComponent as ChevronDownIcon } from "../../assets/general/chevron-down.svg";
import { ReactComponent as ChevronUpIcon } from "../../assets/general/chevron-up.svg";
import { ReactComponent as CollapseLeftIcon } from "../../assets/general/collapse-left.svg";
import { ReactComponent as CollapseRightIcon } from "../../assets/general/collapse-right.svg";
import { ReactComponent as ComplAiIcon } from "../../assets/general/compl-ai.svg";
import { ReactComponent as CompletedIcon } from "../../assets/general/completed.svg";
import { ReactComponent as CopyIcon } from "../../assets/general/copy.svg";
import { ReactComponent as CreateIcon } from "../../assets/general/create.svg";
import { ReactComponent as CreatedByFairoIcon } from "../../assets/general/created-by-fairo.svg";
import { ReactComponent as CrossIcon } from "../../assets/general/cross.svg";
import { ReactComponent as DependencyIcon } from "../../assets/general/dependency.svg";
import { ReactComponent as DeployLG } from "../../assets/general/deploy-lg.svg";
import { ReactComponent as DeployXS } from "../../assets/general/deploy-xs.svg";
import { ReactComponent as DialogCloseDarkIcon } from "../../assets/general/dialog-close-icon-dark.svg";
import { ReactComponent as DialogCloseLightIcon } from "../../assets/general/dialog-close-icon-light.svg";
import { ReactComponent as DiscoverIcon } from "../../assets/general/discover.svg";
import { ReactComponent as DownloadDarkIcon } from "../../assets/general/download-icon-dark.svg";
import { ReactComponent as DownloadIcon } from "../../assets/general/download-icon.svg";
import { ReactComponent as DropdownIcon } from "../../assets/general/dropdown.svg";
import { ReactComponent as EdgeIcon } from "../../assets/general/edge.svg";
import { ReactComponent as EditDarkIcon } from "../../assets/general/edit-icon-dark.svg";
import { ReactComponent as EditLightIcon } from "../../assets/general/edit-icon-light.svg";
import { ReactComponent as EllipseDarkIcon } from "../../assets/general/ellipse-icon-dark.svg";
import { ReactComponent as EllipseLightIcon } from "../../assets/general/ellipse-icon-light.svg";
import { ReactComponent as EmptyImageIcon } from "../../assets/general/empty-image.svg";
import { ReactComponent as EndScreenIcon } from "../../assets/general/end-screen.svg";
import { ReactComponent as ExpandIcon } from "../../assets/general/expand.svg";
import { ReactComponent as FairoAIIcon } from "../../assets/general/fairo-ai.svg";
import { ReactComponent as FilePlus } from "../../assets/general/file-plus.svg";
import { ReactComponent as FolderPlus } from "../../assets/general/folder-plus.svg";
import { ReactComponent as ForwardSlashIcon } from "../../assets/general/forward-slash.svg";
import { ReactComponent as GoogleIcon } from "../../assets/general/google-icon.svg";
import { ReactComponent as HideDarkIcon } from "../../assets/general/hide-icon-dark.svg";
import { ReactComponent as HideLightIcon } from "../../assets/general/hide-icon-light.svg";
import { ReactComponent as HyperlinkIcon } from "../../assets/general/hyperlink.svg";
import { ReactComponent as InviteIcon } from "../../assets/general/invite.svg";
import { ReactComponent as KPIIcon } from "../../assets/general/kpi.svg";
import { ReactComponent as LaunchIcon } from "../../assets/general/launch.svg";
import { ReactComponent as LayoutIcon } from "../../assets/general/layout.svg";
import { ReactComponent as ListsIcon } from "../../assets/general/lists.svg";
import { ReactComponent as MetricsLightIcon } from "../../assets/general/metrics-empty.svg";
import { ReactComponent as MetricsIcon } from "../../assets/general/metrics.svg";
import { ReactComponent as MicrosoftIcon } from "../../assets/general/microsoft-icon.svg";
import { ReactComponent as MoreInfoIcon } from "../../assets/general/more-info.svg";
import { ReactComponent as NewTabIcon } from "../../assets/general/new-tab.svg";
import { ReactComponent as OAuthDarkIcon } from "../../assets/general/oauth-dark.svg";
import { ReactComponent as OAuthLightIcon } from "../../assets/general/oauth-light.svg";
import { ReactComponent as OutputIcon } from "../../assets/general/output.svg";
import { ReactComponent as OverrideIcon } from "../../assets/general/override.svg";
import { ReactComponent as PlayIcon } from "../../assets/general/play.svg";
import { ReactComponent as PluginIcon } from "../../assets/general/plugin.svg";
import { ReactComponent as PlusIcon } from "../../assets/general/plus.svg";
import { ReactComponent as PolicyEditorIcon } from "../../assets/general/policy-editor.svg";
import { ReactComponent as PotentialRisksIcon } from "../../assets/general/potential-risks.svg";
import { ReactComponent as ReLaunchIcon } from "../../assets/general/re-launch.svg";
import { ReactComponent as ReadonlyIcon } from "../../assets/general/readonly.svg";
import { ReactComponent as RegulationsIcon } from "../../assets/general/regulations.svg";
import { ReactComponent as RejectIcon } from "../../assets/general/reject.svg";
import { ReactComponent as ReportsGenerateIcon } from "../../assets/general/reports-generate.svg";
import { ReactComponent as ReportsListIcon } from "../../assets/general/reports-list.svg";
import { ReactComponent as SendIcon } from "../../assets/general/send.svg";
import { ReactComponent as ShowDarkIcon } from "../../assets/general/show-icon-dark.svg";
import { ReactComponent as ShowLightIcon } from "../../assets/general/show-icon-light.svg";
import { ReactComponent as ShrinkIcon } from "../../assets/general/shrink.svg";
import { ReactComponent as SingleChoiceIcon } from "../../assets/general/single-choice.svg";
import { ReactComponent as SuggestedActionsIcon } from "../../assets/general/suggested-actions.svg";
import { ReactComponent as ThreeDotsVerticalDark } from "../../assets/general/three-dots-vertical-dark.svg";
import { ReactComponent as ThreeDotsVertical } from "../../assets/general/three-dots-vertical.svg";
import { ReactComponent as TickIcon } from "../../assets/general/tick.svg";
import { ReactComponent as TooltipBackgroundIcon } from "../../assets/general/tooltip-bg.svg";
import { ReactComponent as TooltipNoBackgroundIcon } from "../../assets/general/tooltip-nobg.svg";
import { ReactComponent as TooltipIcon } from "../../assets/general/tooltip.svg";
import { ReactComponent as TourIcon } from "../../assets/general/tour.svg";
import { ReactComponent as TriggerIcon } from "../../assets/general/trigger.svg";
import { ReactComponent as UnlinkIcon } from "../../assets/general/unlink.svg";
import { ReactComponent as UnlockDarkIcon } from "../../assets/general/unlock-dark.svg";
import { ReactComponent as UnlockLightIcon } from "../../assets/general/unlock-light.svg";
import { ReactComponent as UploadIcon } from "../../assets/general/upload.svg";
import { ReactComponent as VersionHistoryIcon } from "../../assets/general/version-history.svg";
import { ReactComponent as VideoGuidesIcon } from "../../assets/general/video-guides.svg";
import { ReactComponent as WatchIcon } from "../../assets/general/watch.svg";
import { ReactComponent as WelcomeToFairoIcon } from "../../assets/general/welcome-to-fairo.svg";
import { ReactComponent as WizardIcon } from "../../assets/general/wizard.svg";
import { ReactComponent as WrenchIcon } from "../../assets/general/wrench.svg";
import { ReactComponent as YesOrNoIcon } from "../../assets/general/yes-no.svg";
import { ReactComponent as CanadianAlgorithmicIcon } from "../../assets/impactAssessment/canadian-algorithmic.svg";
import { ReactComponent as EqualAIAlgorithmicIcon } from "../../assets/impactAssessment/equal-ai-algorithmic.svg";
import { ReactComponent as ImpactAssessmentLoadingIcon } from "../../assets/impactAssessment/loading.svg";
import { ReactComponent as MicrosoftRaiIcon } from "../../assets/impactAssessment/microsoft-rai.svg";
import { ReactComponent as OCEDAlgorithmicIcon } from "../../assets/impactAssessment/oced-algorithmic.svg";
import { ReactComponent as USCIOCouncilAlgorithmicIcon } from "../../assets/impactAssessment/us-cio-council-algorithmic.svg";
import { ReactComponent as FairoLogoDark } from "../../assets/logo/fairo-logo-dark.svg";
import { ReactComponent as FairoLogoLight } from "../../assets/logo/fairo-logo-light.svg";
import { ReactComponent as FairoLogoWhite } from "../../assets/logo/fairo-logo-white.svg";
import { ReactComponent as ActionIcon } from "../../assets/navbarIcons/action.svg";
import { ReactComponent as AILifecycleIcon } from "../../assets/navbarIcons/ai-lifecycle.svg";
import { ReactComponent as AssetIcon } from "../../assets/navbarIcons/asset.svg";
import { ReactComponent as ComplianceIcon } from "../../assets/navbarIcons/compliance.svg";
import { ReactComponent as ControlsIcon } from "../../assets/navbarIcons/controls.svg";
import { ReactComponent as DatasetIcon } from "../../assets/navbarIcons/datasets.svg";
import { ReactComponent as DocumentationIcon } from "../../assets/navbarIcons/documentation.svg";
import { ReactComponent as DownArrow } from "../../assets/navbarIcons/down-arrow.svg";
import { ReactComponent as EmptyBoxIcon } from "../../assets/navbarIcons/empty-box.svg";
import { ReactComponent as EvidenceTestsIcon } from "../../assets/navbarIcons/evidence-tests.svg";
import { ReactComponent as ExternalResourcesIcon } from "../../assets/navbarIcons/external-resources.svg";
import { ReactComponent as LeftArrow } from "../../assets/navbarIcons/left-arrow.svg";
import { ReactComponent as LockIcon } from "../../assets/navbarIcons/lock.svg";
import { ReactComponent as MLFlowActive } from "../../assets/navbarIcons/mlflow-active.svg";
import { ReactComponent as MLFlowDisabled } from "../../assets/navbarIcons/mlflow-disable.svg";
import { ReactComponent as ModelIcon } from "../../assets/navbarIcons/models.svg";
import { ReactComponent as NoVisibleIcon } from "../../assets/navbarIcons/no-visible.svg";
import { ReactComponent as NotStartedIcon } from "../../assets/navbarIcons/not-started.svg";
import { ReactComponent as NotificationAlertIcon } from "../../assets/navbarIcons/notification-with-alert.svg";
import { ReactComponent as NotificationIcon } from "../../assets/navbarIcons/notification.svg";
import { ReactComponent as OrganizationIcon } from "../../assets/navbarIcons/organization.svg";
import { ReactComponent as PolicySmIcon } from "../../assets/navbarIcons/policy-sm.svg";
import { ReactComponent as PolicyIcon } from "../../assets/navbarIcons/policy.svg";
import { ReactComponent as QuestionnaireIcon } from "../../assets/navbarIcons/questionnaire.svg";
import { ReactComponent as ResourcesIcon } from "../../assets/navbarIcons/resources.svg";
import { ReactComponent as RightArrow } from "../../assets/navbarIcons/right-arrow.svg";
import { ReactComponent as RoleIcon } from "../../assets/navbarIcons/role.svg";
import { ReactComponent as SettingsIconDark } from "../../assets/navbarIcons/settings-dark.svg";
import { ReactComponent as SettingsIcon } from "../../assets/navbarIcons/settings.svg";
import { ReactComponent as SignoutIcon } from "../../assets/navbarIcons/signout.svg";
import { ReactComponent as TestCaseIcon } from "../../assets/navbarIcons/test-cases.svg";
import { ReactComponent as TestIcon } from "../../assets/navbarIcons/test.svg";
import { ReactComponent as DarkThemeIcon } from "../../assets/navbarIcons/theme-dark.svg";
import { ReactComponent as LightThemeIcon } from "../../assets/navbarIcons/theme-light.svg";
import { ReactComponent as TopArrow } from "../../assets/navbarIcons/top-arrow.svg";
import { ReactComponent as TrashCanIcon } from "../../assets/navbarIcons/trash-can.svg";
import { ReactComponent as UserDarkIcon } from "../../assets/navbarIcons/user-dark.svg";
import { ReactComponent as UserLightIcon } from "../../assets/navbarIcons/user-light.svg";
import { ReactComponent as VendorIcon } from "../../assets/navbarIcons/vendor.svg";
import { ReactComponent as WorkflowIcon } from "../../assets/navbarIcons/workflow.svg";
import { ReactComponent as AssestsPaywallIcon } from "../../assets/paywall/assets.svg";
import { ReactComponent as CompliancePaywallIcon } from "../../assets/paywall/compliance.svg";
import { ReactComponent as MlflowPaywallIcon } from "../../assets/paywall/mlflow.svg";
import { ReactComponent as PoliciesPaywallIcon } from "../../assets/paywall/policies.svg";
import { ReactComponent as ResourcesPaywallIcon } from "../../assets/paywall/resources.svg";
import { ReactComponent as TestsPaywallIcon } from "../../assets/paywall/tests.svg";
import { ReactComponent as WorkflowsPaywallIcon } from "../../assets/paywall/workflows.svg";
import { ReactComponent as AwsDarkIcon } from "../../assets/pluginIcons/aws-dark.svg";
import { ReactComponent as AwsLightIcon } from "../../assets/pluginIcons/aws-light.svg";
import { ReactComponent as AzureDarkIcon } from "../../assets/pluginIcons/azure-dark.svg";
import { ReactComponent as AzureLightIcon } from "../../assets/pluginIcons/azure-light.svg";
import { ReactComponent as ConfluenceDarkIcon } from "../../assets/pluginIcons/confluence-dark.svg";
import { ReactComponent as ConfluenceLightIcon } from "../../assets/pluginIcons/confluence-light.svg";
import { ReactComponent as DatabricksIcon } from "../../assets/pluginIcons/databricks.svg";
import { ReactComponent as DropboxDarkIcon } from "../../assets/pluginIcons/dropbox-dark.svg";
import { ReactComponent as DropboxLightIcon } from "../../assets/pluginIcons/dropbox-light.svg";
import { ReactComponent as GithubDarkIcon } from "../../assets/pluginIcons/github-dark.svg";
import { ReactComponent as GithubLightIcon } from "../../assets/pluginIcons/github-light.svg";
import { ReactComponent as HuggingFaceDarkIcon } from "../../assets/pluginIcons/hugging-face-dark.svg";
import { ReactComponent as HuggingFaceLightIcon } from "../../assets/pluginIcons/hugging-face-light.svg";
import { ReactComponent as JiraDarkIcon } from "../../assets/pluginIcons/jira-dark.svg";
import { ReactComponent as JiraLightIcon } from "../../assets/pluginIcons/jira-light.svg";
import { ReactComponent as OpenAIDarkIcon } from "../../assets/pluginIcons/open-ai-dark.svg";
import { ReactComponent as OpenAILightIcon } from "../../assets/pluginIcons/open-ai-light.svg";
import { ReactComponent as SharePointDarkIcon } from "../../assets/pluginIcons/sharepoint-dark.svg";
import { ReactComponent as SharePointLightIcon } from "../../assets/pluginIcons/sharepoint-light.svg";
import { ReactComponent as SlackDarkIcon } from "../../assets/pluginIcons/slack-dark.svg";
import { ReactComponent as SlackLightIcon } from "../../assets/pluginIcons/slack-light.svg";
import { ReactComponent as AllIcon } from "../../assets/templateIcons/all.svg";
import { ReactComponent as ConstructionIcon } from "../../assets/templateIcons/construction.svg";
import { ReactComponent as FinanceIcon } from "../../assets/templateIcons/finance.svg";
import { ReactComponent as HealthcareIcon } from "../../assets/templateIcons/healthcare.svg";
import { ReactComponent as InsuranceIcon } from "../../assets/templateIcons/insurance.svg";
import { ReactComponent as TraceIcon } from "../../assets/general/trace.svg";
import { ReactComponent as InterfaceIcon } from "../../assets/general/interface.svg";

import CloseIcon from "@mui/icons-material/CloseRounded";
import MenuIcon from "@mui/icons-material/Menu";
import { Box, Theme, useTheme } from "@mui/material";
import { useSubscription } from "../../context/SubscriptionContext";
import { getPlanHierarchy } from "../../utilities/PlanHierarchy";
import {
  DEFAULT_ICON_HEIGHT,
  DEFAULT_ICON_WIDTH,
  DEFAULT_INTERNAL_BORDER_RADIUS,
} from "../../utilities/UIHelper";

export type INavbarIconVariant =
  | "organization"
  | "workflow"
  | "test"
  | "test-sm"
  | "asset"
  | "role"
  | "action"
  | "user"
  | "notification"
  | "notification_alert"
  | "light-theme"
  | "dark-theme"
  | "signout"
  | "right-arrow"
  | "left-arrow"
  | "menu"
  | "close"
  | "fairo-logo"
  | "download-logo"
  | "download-dark-logo"
  | "no-visible"
  | "show"
  | "hide"
  | "ellipse"
  | "dialog-close"
  | "add-icon"
  | "edit-icon"
  | "calendar"
  | "chevron-down"
  | "edit-icon"
  | "tooltip"
  | "metrics"
  | "metrics-empty"
  | "created-by-fairo"
  | "compliance"
  | "evidence-pending"
  | "evidence-overdue"
  | "evidence-completed"
  | "google-icon"
  | "microsoft-icon"
  | "mlflow"
  | "policy"
  | "policy-sm"
  | "lock"
  | "audit-log"
  | "version-history"
  | "copy"
  | "aws"
  | "azure"
  | "confluence"
  | "dropbox"
  | "github"
  | "hugging-face"
  | "jira"
  | "open-ai"
  | "sharepoint"
  | "slack"
  | "unlock"
  | "readonly"
  | "empty-box"
  | "trash-can"
  | "chevron-up"
  | "resources"
  | "check"
  | "more-info"
  | "folder-plus"
  | "file-plus"
  | "questionnaire"
  | "empty-image"
  | "radio-checked"
  | "radio-unchecked"
  | "reports-list"
  | "reports-generate"
  | "welcome-to-fairo"
  | "completed"
  | "assets-paywall"
  | "compliance-paywall"
  | "mlflow-paywall"
  | "policies-paywall"
  | "resources-paywall"
  | "tests-paywall"
  | "workflows-paywall"
  | "impact-assessment-loading"
  | "top-arrow"
  | "down-arrow"
  | "not-started"
  | "fairo-ai"
  | "potential-risks"
  | "regulations"
  | "suggested-actions"
  | "nist-logo"
  | "iso-logo"
  | "euai-logo"
  | "hitrust-logo"
  | "vendor-registry"
  | "use-case-registry"
  | "custom-registry"
  | "canadian-algorithmic"
  | "equal-ai-algorithmic"
  | "microsoft-rai"
  | "oced-algorithmic"
  | "us-cio-coucil-algorithmic"
  | "tick"
  | "launch"
  | "re-launch"
  | "documentation"
  | "evidence-tests"
  | "ai-lifecycle"
  | "external-resources"
  | "plugin"
  | "policy-editor"
  | "upload"
  | "risk-scenario"
  | "unlink"
  | "hyperlink"
  | "controls"
  | "three-dots-vertical"
  | "chevron-up-sm"
  | "chevron-down-sm"
  | "oauth"
  | "theme"
  | "settings"
  | "send"
  | "vendor"
  | "databricks"
  | "models"
  | "datasets"
  | "override"
  | "append"
  | "reject"
  | "caution"
  | "ai-nobg"
  | "tour"
  | "wizard"
  | "layout"
  | "plus"
  | "collapse-left"
  | "collapse-right"
  | "tooltip-nobg"
  | "dependency"
  | "agent-executor"
  | "output"
  | "expand"
  | "shrink"
  | "watch"
  | "cross"
  | "agents-connector"
  | "create"
  | "discover"
  | "video-guides"
  | "invite"
  | "all"
  | "healthcare"
  | "finance"
  | "insurance"
  | "construction"
  | "wrench"
  | "trigger"
  | "compl-ai"
  | "kpi"
  | "single-choice"
  | "dropdown"
  | "yes-no"
  | "tooltip-bg"
  | "forward-slash"
  | "end-screen"
  | "edge"
  | "play"
  | "fairo-white"
  | "lists"
  | "new-tab"
  | "deploy-xs"
  | "deploy-white"
  | "deploy-lg"
  | "trace"
  | "interface";

interface INavbarIcons {
  variant: INavbarIconVariant;
  selected?: boolean;
  color?: string;
  backgroundColor?: string;
  strokeWidth?: string;
  sx?: {
    minHeight?: string;
    minWidth?: string;
    width?: string;
    height?: string;
    padding?: string;
    fill?: string;
  };
  activeMLFlow?: boolean;
}

const Icon = ({
  variant,
  style,
  theme,
  activeMLFlow = false,
}: {
  variant: INavbarIconVariant;
  style: any;
  theme: Theme;
  activeMLFlow?: boolean;
}) => {
  const isDarkTheme = theme.palette.mode === "dark";
  const { currentPlan } = useSubscription();
  const isMLFlowSubscribed =
    activeMLFlow ||
    getPlanHierarchy(currentPlan?.name ?? "") >= getPlanHierarchy("Fairo Enterprise");
  switch (variant) {
    case "organization":
      return <OrganizationIcon style={style} />;
    case "workflow":
      return <WorkflowIcon style={style} />;
    case "evidence-tests":
      return <TestIcon style={style} />;
    case "asset":
      return <AssetIcon style={style} />;
    case "role":
      return <RoleIcon style={style} />;
    case "action":
      return <ActionIcon style={style} />;
    case "notification":
      return <NotificationIcon style={style} />;
    case "notification_alert":
      return <NotificationAlertIcon style={style} />;
    case "light-theme":
      return <LightThemeIcon style={style} />;
    case "dark-theme":
      return <DarkThemeIcon style={style} />;
    case "signout":
      return <SignoutIcon style={style} />;
    case "right-arrow":
      return <RightArrow style={style} />;
    case "left-arrow":
      return <LeftArrow style={style} />;
    case "menu":
      return <MenuIcon style={style} />;
    case "close":
      return <CloseIcon style={style} />;
    case "fairo-logo":
      return isDarkTheme ? <FairoLogoDark style={style} /> : <FairoLogoLight style={style} />;
    case "fairo-white":
      return <FairoLogoWhite style={style} />;
    case "download-logo":
      return isDarkTheme ? <DownloadDarkIcon style={style} /> : <DownloadIcon style={style} />;
    case "download-dark-logo":
      return <DownloadDarkIcon style={style} />;
    case "no-visible":
      return <NoVisibleIcon style={style} />;
    case "metrics":
      return <MetricsIcon style={style} />;
    case "metrics-empty":
      return <MetricsLightIcon style={style} />;
    case "chevron-down":
      return <ChevronDownIcon style={style} />;
    case "user":
      return isDarkTheme ? <UserDarkIcon style={style} /> : <UserLightIcon style={style} />;
    case "show":
      return isDarkTheme ? <ShowDarkIcon style={style} /> : <ShowLightIcon style={style} />;
    case "hide":
      return isDarkTheme ? <HideDarkIcon style={style} /> : <HideLightIcon style={style} />;
    case "ellipse":
      return isDarkTheme ? <EllipseDarkIcon style={style} /> : <EllipseLightIcon style={style} />;
    case "dialog-close":
      return isDarkTheme ? (
        <DialogCloseDarkIcon style={style} />
      ) : (
        <DialogCloseLightIcon style={style} />
      );
    case "add-icon":
      return <AddIcon style={style} />;
    case "edit-icon":
      return isDarkTheme ? <EditDarkIcon style={style} /> : <EditLightIcon style={style} />;
    case "calendar":
      return isDarkTheme ? <CalendarDarkIcon style={style} /> : <CalendarLightIcon style={style} />;
    case "tooltip":
      return <TooltipIcon style={style} />;
    case "created-by-fairo":
      return <CreatedByFairoIcon style={style} />;
    case "compliance":
      return <ComplianceIcon style={style} />;
    case "evidence-pending":
      return (
        <EvidencePendingIcon style={{ ...style, stroke: theme.palette.custom.yellowTypography }} />
      );
    case "evidence-overdue":
      return <EvidenceOverdueIcon style={style} />;
    case "evidence-completed":
      return <EvidenceCompletedIcon style={style} />;
    case "google-icon":
      return <GoogleIcon style={style} />;
    case "microsoft-icon":
      return <MicrosoftIcon style={style} />;
    case "mlflow":
      return isMLFlowSubscribed ? <MLFlowActive style={style} /> : <MLFlowDisabled style={style} />;
    case "policy":
      return <PolicyIcon style={style} />;
    case "policy-sm":
      return <PolicySmIcon style={style} />;
    case "lock":
      return <LockIcon style={style} />;
    case "audit-log":
      return <AuditLogIcon style={style} />;
    case "version-history":
      return <VersionHistoryIcon style={style} />;
    case "copy":
      return <CopyIcon style={style} />;
    case "aws":
      return isDarkTheme ? <AwsDarkIcon style={style} /> : <AwsLightIcon style={style} />;
    case "azure":
      return isDarkTheme ? <AzureDarkIcon style={style} /> : <AzureLightIcon style={style} />;
    case "confluence":
      return isDarkTheme ? (
        <ConfluenceDarkIcon style={style} />
      ) : (
        <ConfluenceLightIcon style={style} />
      );
    case "dropbox":
      return isDarkTheme ? <DropboxDarkIcon style={style} /> : <DropboxLightIcon style={style} />;
    case "github":
      return isDarkTheme ? <GithubDarkIcon style={style} /> : <GithubLightIcon style={style} />;
    case "databricks":
      return <DatabricksIcon style={style} />;
    case "hugging-face":
      return isDarkTheme ? (
        <HuggingFaceDarkIcon style={style} />
      ) : (
        <HuggingFaceLightIcon style={style} />
      );
    case "jira":
      return isDarkTheme ? <JiraDarkIcon style={style} /> : <JiraLightIcon style={style} />;
    case "open-ai":
      return isDarkTheme ? <OpenAIDarkIcon style={style} /> : <OpenAILightIcon style={style} />;
    case "sharepoint":
      return isDarkTheme ? (
        <SharePointDarkIcon style={style} />
      ) : (
        <SharePointLightIcon style={style} />
      );
    case "slack":
      return isDarkTheme ? <SlackDarkIcon style={style} /> : <SlackLightIcon style={style} />;
    case "unlock":
      return isDarkTheme ? <UnlockDarkIcon style={style} /> : <UnlockLightIcon style={style} />;
    case "readonly":
      return <ReadonlyIcon style={style} />;
    case "empty-box":
      return <EmptyBoxIcon style={{ ...style }} />;
    case "trash-can":
      return <TrashCanIcon style={{ ...style }} />;
    case "chevron-up":
      return <ChevronUpIcon style={{ ...style }} />;
    case "chevron-up-sm":
      return (
        <ChevronUpIcon
          style={{
            ...style,
            width: "14px",
            minWidth: "14px",
            height: "6px",
            minHeight: "6px",
          }}
        />
      );
    case "chevron-down-sm":
      return (
        <ChevronDownIcon
          style={{
            ...style,
            width: "14px",
            minWidth: "14px",
            height: "6px",
            minHeight: "6px",
          }}
        />
      );
    case "resources":
      return <ResourcesIcon style={{ ...style }} />;
    case "check":
      return <CheckIcon style={{ ...style }} />;
    case "more-info":
      return <MoreInfoIcon style={{ ...style }} />;
    case "folder-plus":
      return <FolderPlus style={{ ...style }} />;
    case "file-plus":
      return <FilePlus style={{ ...style }} />;
    case "questionnaire":
      return <QuestionnaireIcon style={{ ...style }} />;
    case "empty-image":
      return <EmptyImageIcon style={{ ...style }} />;
    case "radio-checked":
      const color = theme.palette.custom.hyperlink;
      return <RadioButtonChecked style={{ ...style, stroke: color, color: color }} />;
    case "radio-unchecked":
      const uncheckedColor = isDarkTheme
        ? theme.palette.custom.white
        : theme.palette.custom.disabledButton;
      return (
        <RadioButtonUnchecked style={{ ...style, stroke: uncheckedColor, color: uncheckedColor }} />
      );
    case "reports-list":
      return <ReportsListIcon style={{ ...style }} />;
    case "reports-generate":
      return <ReportsGenerateIcon style={{ ...style }} />;
    case "welcome-to-fairo":
      return <WelcomeToFairoIcon style={{ ...style }} />;
    case "completed":
      return <CompletedIcon style={{ ...style }} />;
    case "assets-paywall":
      return <AssestsPaywallIcon style={{ ...style }} />;
    case "compliance-paywall":
      return <CompliancePaywallIcon style={{ ...style }} />;
    case "mlflow-paywall":
      return <MlflowPaywallIcon style={{ ...style }} />;
    case "policies-paywall":
      return <PoliciesPaywallIcon style={{ ...style }} />;
    case "resources-paywall":
      return <ResourcesPaywallIcon style={{ ...style }} />;
    case "tests-paywall":
      return <TestsPaywallIcon style={{ ...style }} />;
    case "workflows-paywall":
      return <WorkflowsPaywallIcon style={{ ...style }} />;
    case "impact-assessment-loading":
      return <ImpactAssessmentLoadingIcon style={{ ...style }} />;
    case "down-arrow":
      return <DownArrow style={{ ...style }} />;
    case "top-arrow":
      return <TopArrow style={{ ...style }} />;
    case "not-started":
      return <NotStartedIcon style={{ ...style }} />;
    case "fairo-ai":
      return <FairoAIIcon style={{ ...style }} />;
    case "potential-risks":
      return <PotentialRisksIcon style={{ ...style }} />;
    case "regulations":
      return <RegulationsIcon style={{ ...style }} />;
    case "suggested-actions":
      return <SuggestedActionsIcon style={{ ...style }} />;
    case "nist-logo":
      return isDarkTheme ? (
        <NistLogoDark style={{ ...style }} />
      ) : (
        <NistLogo style={{ ...style }} />
      );
    case "iso-logo":
      return isDarkTheme ? <IsoLogoDark style={{ ...style }} /> : <IsoLogo style={{ ...style }} />;
    case "euai-logo":
      return <EuaiLogo style={{ ...style }} />;
    case "hitrust-logo":
      return isDarkTheme ? (
        <HITRUSTDark style={{ ...style }} />
      ) : (
        <HITRUSTLight style={{ ...style }} />
      );
    case "vendor-registry":
      return isDarkTheme ? (
        <VendorRegistryDark style={{ ...style }} />
      ) : (
        <VendorRegistry style={{ ...style }} />
      );
    case "use-case-registry":
      return isDarkTheme ? (
        <UseCaseRegistryDark style={{ ...style }} />
      ) : (
        <UseCaseRegistry style={{ ...style }} />
      );
    case "custom-registry":
      return isDarkTheme ? (
        <CustomRegistryDark style={{ ...style }} />
      ) : (
        <CustomRegistry style={{ ...style }} />
      );
    case "canadian-algorithmic":
      return <CanadianAlgorithmicIcon style={{ ...style }} />;
    case "equal-ai-algorithmic":
      return <EqualAIAlgorithmicIcon style={{ ...style }} />;
    case "microsoft-rai":
      return <MicrosoftRaiIcon style={{ ...style }} />;
    case "oced-algorithmic":
      return <OCEDAlgorithmicIcon style={{ ...style }} />;
    case "us-cio-coucil-algorithmic":
      return <USCIOCouncilAlgorithmicIcon style={{ ...style }} />;
    case "tick":
      const isDefaultGrey = style.stroke === theme.palette.custom.grey[500];
      return (
        <TickIcon
          style={{ ...style, stroke: isDefaultGrey ? theme.palette.custom.white : style.stroke }}
        />
      );
    case "launch":
      return <LaunchIcon style={{ ...style }} />;
    case "re-launch":
      return <ReLaunchIcon style={{ ...style }} />;
    case "documentation":
      return <DocumentationIcon style={{ ...style }} />;
    case "test":
      return <EvidenceTestsIcon style={{ ...style }} />;
    case "test-sm":
      return <TestCaseIcon style={{ ...style }} />;
    case "ai-lifecycle":
      return <AILifecycleIcon style={{ ...style }} />;
    case "external-resources":
      return <ExternalResourcesIcon style={{ ...style }} />;
    case "plugin":
      return <PluginIcon style={{ ...style }} />;
    case "policy-editor":
      return <PolicyEditorIcon style={{ ...style }} />;
    case "upload":
      return <UploadIcon style={{ ...style }} />;
    case "risk-scenario":
      return <RiskScenarioIcon style={{ ...style }} />;
    case "unlink":
      return <UnlinkIcon style={{ ...style }} />;
    case "hyperlink":
      return <HyperlinkIcon style={{ ...style }} />;
    case "controls":
      return <ControlsIcon style={{ ...style }} />;
    case "three-dots-vertical":
      return isDarkTheme ? (
        <ThreeDotsVerticalDark style={{ ...style }} />
      ) : (
        <ThreeDotsVertical style={{ ...style }} />
      );
    case "oauth":
      return isDarkTheme ? (
        <OAuthDarkIcon style={{ ...style }} />
      ) : (
        <OAuthLightIcon style={{ ...style }} />
      );
    case "theme":
      return isDarkTheme ? (
        <DarkThemeIcon style={{ ...style }} />
      ) : (
        <LightThemeIcon style={{ ...style }} />
      );
    case "settings":
      return isDarkTheme ? (
        <SettingsIconDark style={{ ...style }} />
      ) : (
        <SettingsIcon style={{ ...style }} />
      );
    case "send":
      return <SendIcon style={{ ...style }} />;
    case "vendor":
      return <VendorIcon style={{ ...style }} />;

    case "datasets":
      return <DatasetIcon style={{ ...style }} />;
    case "models":
      return <ModelIcon style={{ ...style }} />;
    case "override":
      return <OverrideIcon style={{ ...style }} />;
    case "append":
      return <AppendIcon style={{ ...style }} />;
    case "reject":
      return <RejectIcon style={{ ...style }} />;
    case "caution":
      return <CautionIcon style={{ ...style }} />;
    case "ai-nobg":
      return isDarkTheme ? (
        <AINoBackgroundDarkIcon style={{ ...style }} />
      ) : (
        <AINoBackgroundIcon style={{ ...style }} />
      );
    case "tour":
      return <TourIcon style={{ ...style }} />;
    case "wizard":
      return <WizardIcon style={{ ...style }} />;
    case "layout":
      return <LayoutIcon style={{ ...style }} />;
    case "plus":
      return <PlusIcon style={{ ...style }} />;
    case "collapse-left":
      return <CollapseLeftIcon style={{ ...style }} />;
    case "collapse-right":
      return <CollapseRightIcon style={{ ...style }} />;
    case "tooltip-nobg":
      return <TooltipNoBackgroundIcon style={{ ...style }} />;
    case "dependency":
      return <DependencyIcon style={{ ...style }} />;
    case "agent-executor":
      return <AgentExecutorIcon style={{ ...style }} />;
    case "output":
      return <OutputIcon style={{ ...style }} />;
    case "expand":
      return <ExpandIcon style={{ ...style }} />;
    case "shrink":
      return <ShrinkIcon style={{ ...style }} />;
    case "watch":
      return <WatchIcon style={{ ...style }} />;
    case "cross":
      return <CrossIcon style={{ ...style }} />;
    case "agents-connector":
      return <AgentsConnectorIcon style={{ ...style }} />;
    case "create":
      return <CreateIcon style={{ ...style }} />;
    case "discover":
      return <DiscoverIcon style={{ ...style }} />;
    case "video-guides":
      return <VideoGuidesIcon style={{ ...style }} />;
    case "invite":
      return <InviteIcon style={{ ...style }} />;
    case "all":
      return <AllIcon style={{ ...style }} />;
    case "healthcare":
      return <HealthcareIcon style={{ ...style }} />;
    case "finance":
      return <FinanceIcon style={{ ...style }} />;
    case "insurance":
      return <InsuranceIcon style={{ ...style }} />;
    case "construction":
      return <ConstructionIcon style={{ ...style }} />;
    case "wrench":
      return <WrenchIcon style={{ ...style }} />;
    case "trigger":
      return <TriggerIcon style={{ ...style }} />;
    case "compl-ai":
      return <ComplAiIcon style={{ ...style }} />;
    case "kpi":
      return <KPIIcon style={{ ...style }} />;
    case "single-choice":
      return <SingleChoiceIcon style={{ ...style }} />;
    case "dropdown":
      return <DropdownIcon style={{ ...style }} />;
    case "yes-no":
      return <YesOrNoIcon style={{ ...style }} />;
    case "tooltip-bg":
      return <TooltipBackgroundIcon style={{ ...style }} />;
    case "forward-slash":
      return <ForwardSlashIcon style={{ ...style }} />;
    case "end-screen":
      return <EndScreenIcon style={{ ...style }} />;
    case "edge":
      return <EdgeIcon style={{ ...style }} />;
    case "play":
      return <PlayIcon style={{ ...style }} />;
    case "lists":
      return <ListsIcon style={{ ...style }} />;
    case "new-tab":
      return <NewTabIcon style={{ ...style }} />;
    case "deploy-xs":
      return (
        <DeployXS style={{ ...style, strokeWidth: 0, fill: theme.palette.custom.grey[500] }} />
      );
    case "deploy-white":
      return <DeployXS style={{ ...style, strokeWidth: 0, fill: theme.palette.custom.white }} />;
    case "deploy-lg":
      return (
        <DeployLG style={{ ...style, fill: theme.palette.custom.grey[500], strokeWidth: 0 }} />
      );
    case "trace":
      return <TraceIcon style={{ ...style }} />;
    case "interface":
      return <InterfaceIcon style={{ ...style }} />;
    default:
      // below line ensures no variant is missed out
      const _: never = variant;
      return <OrganizationIcon style={style} />;
  }
};

export const NavbarIcon = ({
  variant,
  selected,
  color,
  sx,
  backgroundColor,
  strokeWidth,
  activeMLFlow = false,
}: INavbarIcons) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const iconStyle = {
    width: DEFAULT_ICON_WIDTH,
    height: DEFAULT_ICON_HEIGHT,
    strokeWidth,
    stroke: color ? color : selected ? theme.palette.custom.hyperlink : theme.palette.custom.gray,

    ...sx,
  };

  return backgroundColor ? (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={DEFAULT_ICON_WIDTH}
      height={DEFAULT_ICON_HEIGHT}
      borderRadius={DEFAULT_INTERNAL_BORDER_RADIUS}
      sx={{ ...sx, backgroundColor }}
    >
      <Icon
        variant={variant}
        style={{
          strokeWidth: strokeWidth,
          stroke: color
            ? color
            : selected
            ? theme.palette.custom.blue[400]
            : theme.palette.custom.gray,
          width: "100%",
        }}
        theme={theme}
        activeMLFlow={activeMLFlow}
      />
    </Box>
  ) : (
    <Icon variant={variant} style={iconStyle} theme={theme} activeMLFlow={activeMLFlow} />
  );
};
